import {Injectable, OnDestroy, Inject} from '@angular/core';
import {Observable, SubscriptionLike, Subject, Observer, interval, BehaviorSubject, ReplaySubject} from 'rxjs';
import {debounceTime, filter, map} from 'rxjs/operators';
import {WebSocketSubject, WebSocketSubjectConfig} from 'rxjs/webSocket';

import {share, distinctUntilChanged, takeWhile} from 'rxjs/operators';
import {IWebsocketService, IWsMessage, WebSocketConfig} from './websocket.interfaces';
import {config} from './websocket.config';
import {isNull} from 'util';
// import {tag} from "rxjs-spy/operators/tag";
import {log} from '../../functions';

// https://github.com/AlexDaSoul/angular-websocket-starter
@Injectable()
export class WebsocketService implements IWebsocketService, OnDestroy {
  public timeoutSecond = 0;
  public disconnect = false;
  public disconnectedCount = 0;
  ///
  public config: WebSocketSubjectConfig<IWsMessage<any>>;
  private websocketSub: SubscriptionLike;
  private statusSub: SubscriptionLike;
  public type: 'all' | 'whatsapp' = 'all';

  private reconnection$: ReplaySubject<void> = new ReplaySubject();
  public websocket$: WebSocketSubject<IWsMessage<any>>;
  connection$: Observer<boolean>;
  public wsMessages$: Subject<IWsMessage<any>> = new Subject<IWsMessage<any>>();
  public reloadRequests$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private reconnectInterval: number;
  private reconnectAttempts: number;
  public isConnected: boolean;
  public status: Observable<boolean>;
  public roomId: number;

  constructor(@Inject(config) private wsConfig: WebSocketConfig) {
    this.reloadRequests$.pipe(debounceTime(1000)).subscribe((val) => {
      this.reconnection$.next();
    });
    this.reconnectInterval = wsConfig.reconnectInterval || 5000; // pause between connections
    this.reconnectAttempts = wsConfig.reconnectAttempts || 10000000; // number of connection attempts
    // alert( wsConfig.url);
    this.initConfig();
    // connection status
    this.status = new Observable<boolean>((observer) => {
      this.connection$ = observer;
    }).pipe(share());

    // run reconnect if not connection
    this.statusSub = this.status.subscribe((isConnected) => {
      this.isConnected = isConnected;
      if (typeof isConnected === 'boolean' && !isConnected) {
        this.reconnection$.next();
      }
    });

    this.websocketSub = this.wsMessages$.subscribe(null, (error: ErrorEvent) => {
      this.disconnect = true;
      this.disconnectedCount++;
      console.error('WebSocket error!', error);
    });

    /*
     * reconnect if not connecting or errors
     * */
    this.reconnection$.pipe(debounceTime(this.reconnectInterval)).subscribe(() => {
      console.log('WSS REconnect');
      if (this.disconnect) {
        this.connect();
      }
    });
    // this.connect();
  }

  initConfig(): void {
    if (!this.roomId) {
      return;
    }
    this.config = {
      url: this.wsConfig.url + `/ws/chat/${this.roomId}/`,
      closeObserver: {
        next: (event: CloseEvent) => {
          this.websocket$ = null;
          this.disconnect = true;
          this.disconnectedCount++;
          this.connection$.next(false);
        }
      },
      openObserver: {
        next: (event: Event) => {
          this.disconnect = false;
          log('WebSocket connected: ' + this.config.url);
          this.connection$.next(true);
        }
      }
    };
  }

  /*
   * connect to WebSocked
   * */
  public connect(): void {
    console.log('WSS connect');
    this.websocket$ = new WebSocketSubject(this.config, this.wsMessages$);
    this.websocket$.subscribe(
      (message) => {
        this.wsMessages$.next(message);
      },
      (error: Event) => {
        // run reconnect if errors
        this.reconnection$.next();
      },
      () => {
      }
    );
  }

  /*
   * on message event
   * */
  public on<T>(event: string): Observable<T> {
    if (event) {
      return this.wsMessages$.pipe(
        filter((message: IWsMessage<T>) => message.event === event),
        map((message: IWsMessage<T>) => message.data)
      );
    }
  }

  /*
   * on message to server
   * */
  public send(event: string, data: any = {}): void {
    if (event && this.isConnected) {
      this.websocket$.next({type: '', event, data});
    } else {
      console.error('Send error!', this.isConnected, event);
    }
  }

  ngOnDestroy() {
    this.websocketSub.unsubscribe();
    this.statusSub.unsubscribe();
  }
}
